import React from 'react'
import styles from './ChoiceItem.module.scss'
import ActionMenu from 'components/UI/ActionMenu/ActionMenu'

export const ChoiceItem = ({ item, action, index, menu }) => {
  return (
    <div
      className={`${styles.itemContainer} ${index % 2 === 0 ? styles.colorBg : ''}`}
    >
      <div className={styles.containerInf}>
        <div className={`${styles.infStyl} ${styles.name}`}>{item.name}</div>
        <div className={styles.buttons}>
          <ActionMenu
            menu={menu}
            action={(actionType) => action(actionType, null, item)}
          />
        </div>
      </div>
    </div>
  )
}
